<template>
  <div id="userQuestions">
    <div v-if="showPrivacyQuestions || isAdmin">
      <h2>{{$t('message.discussionTabMyQuestions')}}</h2>
      <user-profile-questions :userId="userId" type="MY_QUESTIONS" />
      <h2>{{$t('message.discussionTabMyAnswers')}}</h2>
      <user-profile-questions :userId="userId" type="MY_ANSWERS" />
    </div>
    <p v-if="!showPrivacyQuestions && !isAdmin">{{$t('message.labelDiscussionPrivate')}}</p>
  </div>
</template>
<script>
  import UserProfileQuestions from "../../components/Profile/UserQuestions/UserQuestions";
  import ProfileMixin from "../../mixins/ProfileMixin";
  export default {
    mixins: [
      ProfileMixin
    ],
    components: {UserProfileQuestions},
    data() {
      return {

      }
    },
    computed: {
      userId() {
        let self = this;
        return self.$store.state.activeProfile;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ProfileDiscussion.vue?c484e42a